<mat-form-field appearance="standard" class="field-full-width">
    <mat-label>Imprimantes</mat-label>
    <mat-select>
        <mat-option *ngFor="let printer of print.printers" [value]="printer" (click)="select(printer)">
          {{printer.name}}
        </mat-option>
    </mat-select>
</mat-form-field>